// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { ProductOfferingProgramDataFragmentDoc } from '../../../developments/product-offerings/ProductOfferingsPage.generated';
import { VersionableFragmentDoc } from '../../../../components/ReadyPlanVersionHeader.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ProductOfferingOverviewPanelQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ProductOfferingOverviewPanelQuery = { __typename?: 'Query', productOffering: { __typename?: 'ProductOffering', id: string, name: string, effectiveStatus: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus }, coverAsset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined, minProgramData: { __typename?: 'ProgramData', id: string, depthInFeet?: number | null | undefined, widthInFeet?: number | null | undefined, sellableSqft?: number | null | undefined, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined }, maxProgramData: { __typename?: 'ProgramData', id: string, depthInFeet?: number | null | undefined, widthInFeet?: number | null | undefined, sellableSqft?: number | null | undefined, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined }, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string }, aggregateCheckout?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined, aggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, promotedAt?: Types.Scalars['DateTime']['input'] | null | undefined, promotedBy?: { __typename?: 'User', id: string, name: string } | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus } }>, planPackage: { __typename?: 'PlanPackage', id: string, name: string }, planPackageVersion: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string }, interiorDesignPackage: { __typename?: 'DesignPackage', id: string, name: string, availableUpdates: Array<{ __typename?: 'DesignPackagePlanUpdate', id: string }> }, interiorDesignPackageVersion: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string }, exteriorDesignPackage: { __typename?: 'DesignPackage', id: string, name: string, availableUpdates: Array<{ __typename?: 'DesignPackagePlanUpdate', id: string }> }, exteriorDesignPackageVersion: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string } } };

export type ProductOfferingOverviewPanel_ProductOfferingFragment = { __typename?: 'ProductOffering', id: string, name: string, effectiveStatus: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus }, coverAsset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined, minProgramData: { __typename?: 'ProgramData', id: string, depthInFeet?: number | null | undefined, widthInFeet?: number | null | undefined, sellableSqft?: number | null | undefined, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined }, maxProgramData: { __typename?: 'ProgramData', id: string, depthInFeet?: number | null | undefined, widthInFeet?: number | null | undefined, sellableSqft?: number | null | undefined, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined }, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string }, aggregateCheckout?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined, aggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, promotedAt?: Types.Scalars['DateTime']['input'] | null | undefined, promotedBy?: { __typename?: 'User', id: string, name: string } | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus } }>, planPackage: { __typename?: 'PlanPackage', id: string, name: string }, planPackageVersion: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string }, interiorDesignPackage: { __typename?: 'DesignPackage', id: string, name: string, availableUpdates: Array<{ __typename?: 'DesignPackagePlanUpdate', id: string }> }, interiorDesignPackageVersion: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string }, exteriorDesignPackage: { __typename?: 'DesignPackage', id: string, name: string, availableUpdates: Array<{ __typename?: 'DesignPackagePlanUpdate', id: string }> }, exteriorDesignPackageVersion: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string } };

export const ProductOfferingOverviewPanel_ProductOfferingFragmentDoc = gql`
    fragment ProductOfferingOverviewPanel_ProductOffering on ProductOffering {
  id
  name
  effectiveStatus {
    code
  }
  coverAsset {
    id
    previewUrl(resizing: {width: 680, region: FULL})
  }
  minProgramData {
    ...ProductOfferingProgramData
  }
  maxProgramData {
    ...ProductOfferingProgramData
  }
  aggregateLatest {
    id
  }
  aggregateCheckout {
    id
  }
  aggregateVersions {
    ...Versionable
  }
  planPackage {
    id
    name
  }
  planPackageVersion {
    id
    displayVersion
  }
  interiorDesignPackage {
    id
    name
    availableUpdates {
      id
    }
  }
  interiorDesignPackageVersion {
    id
    displayVersion
  }
  exteriorDesignPackage {
    id
    name
    availableUpdates {
      id
    }
  }
  exteriorDesignPackageVersion {
    id
    displayVersion
  }
}
    ${ProductOfferingProgramDataFragmentDoc}
${VersionableFragmentDoc}`;
export const ProductOfferingOverviewPanelDocument = gql`
    query ProductOfferingOverviewPanel($id: ID!) {
  productOffering(id: $id) {
    ...ProductOfferingOverviewPanel_ProductOffering
  }
}
    ${ProductOfferingOverviewPanel_ProductOfferingFragmentDoc}`;

/**
 * __useProductOfferingOverviewPanelQuery__
 *
 * To run a query within a React component, call `useProductOfferingOverviewPanelQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductOfferingOverviewPanelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductOfferingOverviewPanelQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductOfferingOverviewPanelQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProductOfferingOverviewPanelQuery, ProductOfferingOverviewPanelQueryVariables> & ({ variables: ProductOfferingOverviewPanelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductOfferingOverviewPanelQuery, ProductOfferingOverviewPanelQueryVariables>(ProductOfferingOverviewPanelDocument, options);
      }
export function useProductOfferingOverviewPanelLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductOfferingOverviewPanelQuery, ProductOfferingOverviewPanelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductOfferingOverviewPanelQuery, ProductOfferingOverviewPanelQueryVariables>(ProductOfferingOverviewPanelDocument, options);
        }
// @ts-ignore
export function useProductOfferingOverviewPanelSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingOverviewPanelQuery, ProductOfferingOverviewPanelQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingOverviewPanelQuery, ProductOfferingOverviewPanelQueryVariables>;
export function useProductOfferingOverviewPanelSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingOverviewPanelQuery, ProductOfferingOverviewPanelQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingOverviewPanelQuery | undefined, ProductOfferingOverviewPanelQueryVariables>;
export function useProductOfferingOverviewPanelSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingOverviewPanelQuery, ProductOfferingOverviewPanelQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProductOfferingOverviewPanelQuery, ProductOfferingOverviewPanelQueryVariables>(ProductOfferingOverviewPanelDocument, options);
        }
export type ProductOfferingOverviewPanelQueryHookResult = ReturnType<typeof useProductOfferingOverviewPanelQuery>;
export type ProductOfferingOverviewPanelLazyQueryHookResult = ReturnType<typeof useProductOfferingOverviewPanelLazyQuery>;
export type ProductOfferingOverviewPanelSuspenseQueryHookResult = ReturnType<typeof useProductOfferingOverviewPanelSuspenseQuery>;
export type ProductOfferingOverviewPanelQueryResult = ApolloReactCommon.QueryResult<ProductOfferingOverviewPanelQuery, ProductOfferingOverviewPanelQueryVariables>;